import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { AddReceivingInvoiceViewModel } from "../../../viewmodels/receiving/invoices/AddReceivingInvoiceViewModel";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import SlideOver from "../../../components/slideOver/SlideOver";
import AddReceivingInvoiceForm from "../../../components/forms/receiving/invoices/AddReceivingInvoiceForm";
import EmptyModal from "../../../components/modals/EmptyModal";

function AddReceivingInvoice(props) {
  const { addSnackbar, logout } = props;
  const { purchaseOrderId } = useParams();
  const {
    barcodeDetails,
    linkedPurchaseOrder,
    loadLinkedPurchaseOrder,
    createReceivingInvoice,
    getAllAssemblyItems,
    getAssemblyItemByPlu,
    invoice,
    invoiceItems,
    setInvoiceItems,
    onGenerateBarcodePdf,
    productTypeOptions,
    loading,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    openReceivingItemDetails,
    deleteReceivingItem,
    deleteMultipleReceivingItems,
    getUsersForDropdown,
    employeeOptions,
    suppliers,
    getSuppliersForDropdown,
    getInvoiceProducts,
    getInvoiceLots,
    getInvoiceLotItems,
    lotsLoading,
    itemsLoading,
    getPurchaseOrderForDropdown,
    purchaseOrderOptions,
    getLocationsForDropdown,
    locationOptions,
    zoneOptions,
    loadZonesForLocation,
  } = AddReceivingInvoiceViewModel(logout, addSnackbar, purchaseOrderId);

  useEffect(() => {
    if (purchaseOrderId) {
      loadLinkedPurchaseOrder();
    }
    getUsersForDropdown();
    getSuppliersForDropdown();
    getPurchaseOrderForDropdown();
    getLocationsForDropdown();
  }, [purchaseOrderId]);
  return (
    <div className="min-h-screen bg-[#F6F8FB] px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <AddReceivingInvoiceForm
          addItemToReceivingInvoice={null}
          barcodeDetails={barcodeDetails}
          linkedPurchaseOrder={linkedPurchaseOrder}
          purchaseOrderId={purchaseOrderId}
          createReceivingInvoice={createReceivingInvoice}
          invoice={invoice}
          onGenerateBarcodePdf={onGenerateBarcodePdf}
          productTypeOptions={productTypeOptions}
          getAllAssemblyItems={getAllAssemblyItems}
          getAssemblyItemByPlu={getAssemblyItemByPlu}
          setSlideOver={setSlideOver}
          isEdit={false}
          invoiceItems={invoiceItems}
          setInvoiceItems={setInvoiceItems}
          showErrorModal={showErrorModal}
          openReceivingItemDetails={openReceivingItemDetails}
          deleteReceivingItem={deleteReceivingItem}
          deleteMultipleReceivingItems={deleteMultipleReceivingItems}
          setEmptyModelOpen={setEmptyModelOpen}
          employeeOptions={employeeOptions}
          suppliers={suppliers}
          getInvoiceProducts={getInvoiceProducts}
          getInvoiceLots={getInvoiceLots}
          getInvoiceLotItems={getInvoiceLotItems}
          lotsLoading={lotsLoading}
          itemsLoading={itemsLoading}
          purchaseOrderOptions={purchaseOrderOptions}
          locationOptions={locationOptions}
          zoneOptions={zoneOptions}
          loadZonesForLocation={loadZonesForLocation}
        />
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass="max-w-3xl"
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddReceivingInvoice),
);
